import React from "react";
import { CalendarDaysIcon, ClipboardListIcon, FileCheck2Icon, SearchIcon, TargetIcon, TrendingUpIcon, UsersIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { stages } from "../../data/content";
const icons = [ClipboardListIcon, SearchIcon, TargetIcon, CalendarDaysIcon, TrendingUpIcon, UsersIcon];
export function Pathway() {
  return <section className="bg-plum-900 px-4 py-14 text-white sm:py-20" data-id="element-262" data-mp="38qtqymtnvdzk">
      <div className="mx-auto max-w-4xl" data-id="element-263" data-mp="38sn2aff7ymdw">
        <p className="text-center text-sm font-extrabold text-mint-300" data-id="element-264" data-mp="3crm59uhe492p">Introducing the</p>
        <h2 className="mt-1 text-center font-display text-[30px] font-extrabold leading-tight sm:text-5xl" data-id="element-265" data-mp="3hqp8rahq278k">
          PEDIATRIC FEEDING DECISION PATHWAY™
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-plum-100" data-id="element-266" data-mp="3mo8oyfxzcu35">
          A Practical 6-Stage System for Organizing Pediatric Feeding Assessment and Therapy Planning.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-base leading-relaxed text-plum-200" data-id="element-267" data-mp="12271avf91im0">
          Help you move from scattered case information to a documented assessment summary and individualized therapy
          planning draft. Instead of forcing every feeding case into a rigid protocol, the system provides a flexible
          organizational pathway that supports professional judgment.
        </p>

        <ol className="relative mt-10 space-y-5" data-id="element-268" data-mp="t6n6fh3ftjdx">
          <span className="absolute bottom-6 left-6 top-6 w-0.5 bg-plum-700" aria-hidden="true" data-id="element-269" data-mp="t7geqmi1ogy6" />
          {stages.map((s, i) => {
          const Icon = icons[i];
          return <li key={s.key} className="relative flex gap-4" data-id="element-270" data-mp="kfeeao7z70nw" data-mpi={i}>
                <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-mint-500 text-plum-950" data-id="element-271" data-mp="ffiel16b9ve5">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-272" data-mp="aeudfmodby67" />
                </span>
                <div className="flex-1 rounded-2xl bg-plum-800 p-5" data-id="element-273" data-mp="5i3w6w0tuwj7">
                  <p className="text-xs font-extrabold text-mint-300" data-id="element-274" data-mp="3rz48c9atveoj">
                    STAGE {i + 1} — {s.name.toUpperCase()}
                  </p>
                  <h3 className="mt-1 font-display text-lg font-extrabold leading-snug text-white sm:text-xl" data-id="element-275" data-mp="u4hovtrqjxa">{s.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-plum-100" data-id="element-276" data-mp="3j0iugrgawnu3">{s.text}</p>
                  <p className="mt-3 flex items-start gap-2 rounded-xl bg-plum-950/60 px-3 py-2 text-sm font-bold text-sun" data-id="element-277" data-mp="3n1ud2d0rc8ss">
                    <FileCheck2Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-278" data-mp="jirn5ffuxbbe" />
                    Output: {s.output}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <p className="mt-10 text-center font-display text-xl font-extrabold leading-snug sm:text-2xl" data-id="element-279" data-mp="9s6et0adssfa">
          From Initial Intake to Documented Planning—Without Starting From a Blank Page Every Time.
        </p>
        <div className="mt-6" data-id="element-280" data-mp="12abzd6von72n">
          <CtaButton label="Get the Complete 6-Stage Pathway for $27" data-id="element-281" data-mp="12bdepnjqefq6" />
        </div>
      </div>
    </section>;
}